import { getCurrentRadioProgram, getProgramOffsetSeconds } from "./radioEngine"

import { radioBass } from "@/data/radio/radioBass"
import { radioReggaeton } from "@/data/radio/radioReggaeton"
import { radioBrazilian } from "@/data/radio/radioBrazilian"
import { radioPop } from "@/data/radio/radioPop"
import { radioWorld } from "@/data/radio/radioWorld"

import { voiceEngine } from "@/app/pages/radioPage/hooks/voice/voiceEngine"

import { Program, RadioItem } from "@/types/radio"

/* =========================
   METADATA DE RADIOS (UI)
========================= */
const radioMeta: Record<RadioId, {
  name: string
  emoji: string
  color: string
  desc?: string
}> = {
  bass: {
    name: "Bass Radio",
    emoji: "", //🔊
    color: "#00A3FF",
    desc: "Low-end global bass"
  },
  reggaeton: {
    name: "Reggaeton",
    emoji: "🔥",
    color: "#FF006E",
    desc: "Latin urban vibes"
  },
  brazilian: {
    name: "Brazilian",
    emoji: "🌴",
    color: "#00FF85",
    desc: "Funk carioca + baile"
  },
  pop: {
    name: "Pop",
    emoji: "🎤",
    color: "#FFB800",
    desc: "Hits & charts"
  },
  world: {
    name: "World",
    emoji: "🌍",
    color: "#8A2BE2",
    desc: "Global fusion"
  },
}


/* =========================
   RADIO IDS
========================= */
export type RadioId =
  | "bass"
  | "reggaeton"
  | "brazilian"
  | "pop"
  | "world"

/* =========================
   DÍAS DE LA SEMANA
========================= */
type DiaSemana =
  | "domingo"
  | "lunes"
  | "martes"
  | "miercoles"
  | "jueves"
  | "viernes"
  | "sabado"

/* =========================
   PROGRAMA SEMANAL
========================= */
export type RadioSchedule = Record<DiaSemana, Program[]>

/* =========================
   MAPA DE RADIOS
========================= */
const radiosMap: Record<RadioId, RadioSchedule> = {
  bass: radioBass,
  reggaeton: radioReggaeton,
  brazilian: radioBrazilian,
  pop: radioPop,
  world: radioWorld,
}



/* =========================
   RESOLVE STREAM (INDIVIDUAL RADIO)
========================= */
export function resolveRadioStream(radioId: RadioId, now = new Date()) {
  const radio = radiosMap[radioId]

  const dias: DiaSemana[] = [
    "domingo", "lunes", "martes", "miercoles",
    "jueves", "viernes", "sabado",
  ]

  const hoy = dias[now.getDay()]

  const program = getCurrentRadioProgram(radio, hoy, now) as Program | null

  if (!program) return null

  const offset = getProgramOffsetSeconds(program, now)

  const src = Array.isArray(program.src)
    ? program.src[0]
    : program.src

  return {
    radioId,
    radio,
    program,
    src,
    offset,
  }
}

/* =========================
   GET ACTIVE RADIO
========================= */
export function getActiveRadio(now = new Date()) {
  const dias: DiaSemana[] = [
    "domingo", "lunes", "martes", "miercoles",
    "jueves", "viernes", "sabado",
  ]

  const hoy = dias[now.getDay()]

  for (const [id, radio] of Object.entries(radiosMap)) {
    const program = getCurrentRadioProgram(radio, hoy, now) as Program | null

    if (program) {
      const offset = getProgramOffsetSeconds(program, now)

      const src = Array.isArray(program.src)
        ? program.src[0]
        : program.src

      return {
        radioId: id as RadioId,
        radio,
        program,
        src,
        offset,
      }
    }
  }

  return null
}

/* =========================
   GET SINGLE RADIO
========================= */
export function getRadioById(id: RadioId): RadioSchedule {
  return radiosMap[id]
}

/* =========================
   GET ALL RADIOS STATUS
========================= */
export function getRadiosWithStatus(now = new Date()): RadioItem[] {
  const dias: DiaSemana[] = [
    "domingo", "lunes", "martes", "miercoles",
    "jueves", "viernes", "sabado",
  ]

  const hoy = dias[now.getDay()]

  return Object.entries(radiosMap).map(([id, schedule]) => {
    const program = getCurrentRadioProgram(schedule, hoy, now) as Program | null

    const meta = radioMeta[id as RadioId]

    return {
      id: id as RadioId,
      name: meta.name,
      emoji: meta.emoji,
      desc: meta.name,
      color: meta.color,
      program,
    }
  })
}

